import "./NightCards.css";

interface NightLargeGlowCardSurfaceProps {
  className?: string;
}

export function NightLargeGlowCardSurface({ className = "" }: NightLargeGlowCardSurfaceProps) {
  return (
    <span
      className={["night-large-glow-card-surface", className].filter(Boolean).join(" ")}
      aria-hidden="true"
    />
  );
}
